import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Account from '@/helper/AccountHelper.js';
import { map } from 'rxjs/operators';
import { CreditCardListModelBuilder } from '../model/CreditCardModel';

export default {
    apiGetCardList: function () {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + '/profile';
        return BzbsApi.connectBzbsGet(url, token, null)
            .pipe(map((res) => {

                if (res.data.success) {
                    let list = new CreditCardListModelBuilder()
                    list.parse(res.data.data.Cards, res.data.data.Name)
                    // console.log(list.getList())
                    return list.getList()
                } else {
                    return null
                }
            }));
    },
    /**
     *
     * @param {import("@/core/JCB/model/CreditCardModel").CreditCardModelBuilder} modelBuilder
     */
    apiDeleteCard: function (modelBuilder) {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + '/auth/deletecard';
        return BzbsApi.connectBzbsPost(url, token, modelBuilder.create().getParams()).pipe(map((res) => {
            return res.data.success
        }))
    }
}
